import { render, staticRenderFns } from "./RefundRecord.vue?vue&type=template&id=584b4bf8&scoped=true"
import script from "./RefundRecord.vue?vue&type=script&lang=ts"
export * from "./RefundRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b4bf8",
  null
  
)

export default component.exports